var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "telegram-logo",
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login_5_Phone",
    transform: "translate(-760.000000, -186.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840,346 C795.81722,346 760,310.18278 760,266 C760,221.81722 795.81722,186 840,186 C884.18278,186 920,221.81722 920,266 C920,310.18278 884.18278,346 840,346 Z M794.596303,264.66919 C790.659174,266.234556 788.596733,267.765936 788.408978,269.263329 C788.048509,272.138166 792.188142,273.033142 797.396667,274.725906 C801.643184,276.106018 807.355495,277.720609 810.325092,277.784753 C813.018799,277.842938 816.025284,276.732617 819.344546,274.453789 C841.998088,259.16492 853.691946,251.437186 854.426119,251.270588 C854.944065,251.153055 855.661811,251.005273 856.148118,251.437434 C856.634425,251.869594 856.586618,252.688022 856.535106,252.907586 C856.123224,254.663156 834.84286,274.015606 833.61816,275.287388 C828.938462,280.146996 823.615302,283.120543 831.826781,288.530755 C838.932147,293.212193 843.067503,296.19863 850.387542,300.996094 C855.065474,304.061953 858.733031,307.697601 863.562866,307.253237 C865.785287,307.048765 868.080902,304.959403 869.246762,298.727987 C872.002037,284.001293 877.417883,252.09303 878.669527,238.944397 C878.779187,237.792407 878.641237,236.318088 878.530455,235.670896 C878.419672,235.023705 878.188168,234.101592 877.346762,233.418979 C876.350285,232.610561 874.811937,232.440083 874.123923,232.4522 C870.995743,232.507295 866.196346,234.175802 843.099163,243.78089 C835.009657,247.144954 818.842037,254.107721 794.596303,264.66919 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.4e10bcd5c9ad55a4b4e0fe92b351b997.svg";
export { ForwardRef as ReactComponent };